import React, {useState} from 'react';
import {
  Tabs,
  Tab
} from '@material-ui/core';
import { TabPanel, TabContext } from '@material-ui/lab';
import { BackTo } from 'components';
import BasicCouponCode from './BasicCouponCode';
import ComplexCouponCode from './ComplexCouponCode';


const CreateCouponRule = () => {
  const [tabIndex, setTabIndex] = useState('BasicCouponCode');

  const handleTabChange = (e, value) => setTabIndex(value);

  return (
    <div className="w-full pt-10 pb-25 min-h-full-screen scroll-y">
      <div className="max-w-1000 mx-auto">
        <BackTo
          link="/configurations/coupon-manager#coupon_rules"
          title={
            <div className="text-16 font-medium">
              Create New Coupon Rule
            </div>
          }
        />
        <div className="mt-3">
          <TabContext value={tabIndex}>
            <Tabs
              value={tabIndex}
              onChange={handleTabChange}
              textColor="primary"
              indicatorColor="primary"
            >
              <Tab className="capitalize font-medium font-bold" value="BasicCouponCode" label="Basic Coupon Code" />
              <Tab className="capitalize font-meInfoTooltipdium font-bold" value="ComplexCouponCode" label="Complex Coupon Code" />
            </Tabs>
            <TabPanel value="BasicCouponCode">
              <BasicCouponCode />
            </TabPanel>
            <TabPanel value="ComplexCouponCode">
              <ComplexCouponCode />
            </TabPanel>
          </TabContext>
        </div>
      </div>
    </div>
  );
};

export default CreateCouponRule;
